export const GET_ALL_INVOICES_UNINVOICED_ORDERS =
  'providers/invoicing/InvoicesGlobalProvider/GET_ALL_INVOICES_UNINVOICED_ORDERS';
export const GET_ALL_INVOICES_UNINVOICED_ORDERS_PAGINATION =
  'providers/invoicing/InvoicesGlobalProvider/GET_ALL_INVOICES_UNINVOICED_ORDERS_PAGINATION';
export const GENERATE_INVOICING = 'providers/invoicing/InvoicesGlobalProvider/GENERATE_INVOICING';
